/*
 * @Description: 自动生成代码无需修改，可跑npm run services来重新生成
 */
// import http from '@lib/http';
// import { GetServerSidePropsContext } from 'next';

const ActivitiesNotifySendVerificationCode = async (data, http) => {
  // @ts-ignore
  const res = await http.get('/wemeet-tapi', '/v2/activities/notify/send-verification-code', data);
  return res;
};
export default ActivitiesNotifySendVerificationCode;